// import axios from 'axios';

// const api = async(conf)=>{
//     const result = await axios({
//         method: conf.method,
//         baseURL:'https://apiqa.rooftopmeasurements.com',
//         url:conf.url,
//         data:conf.data,
//         cancelToken:conf.cancelToken,
//         params:conf.params,
//         headers:conf.headers,
//         withCredentials: false,
//         mode:"cors",
//         ...conf
//     })
//     return result.data
// }
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
// api.interceptors.request.use(
//     (config) => {
//       const token = localStorage.getItem('token'); // Retrieve token from storage
//       if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//       }
//       return config;
//     },
//     (error) => {
//       return Promise.reject(error);
//     }
//   );

// export default api;

import axios from "axios";

// Create an Axios instance
const apiInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  // baseURL: "https://api-qa.rooftopmeasurements.com/",
  // baseURL: "https://api.rooftopmeasurements.com/",
  // baseURL: "https://api-beta.rooftopmeasurements.com/",
  withCredentials: false,
  mode: "cors",
});

// Attach the latest token before every request
apiInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Always fetch the latest token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Wrap the instance in a function to keep your existing API call format
const api = async (conf) => {
  try {
    const response = await apiInstance({
      method: conf.method,
      url: conf.url,
      data: conf.data,
      cancelToken: conf.cancelToken,
      params: conf.params,
      headers: conf.headers,
      ...conf, // Ensure any additional properties are passed
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export default api;
